/**
 * Copyright (c) 2022, WSO2 LLC. (https://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
 * You may not alter or remove any copyright or other notice from copies of this content.
 */

import React, { FunctionComponent, PropsWithChildren, ReactElement } from "react";
import { Container, Footer } from "rsuite";
import { AppHeader } from "../components";
import { useConfig } from "../hooks";
import { IdentifiableComponentInterface } from "../models";

/**
 * Error Layout props interface.
 */
export type ErrorLayoutPropsInterface = IdentifiableComponentInterface;

/**
 * Default Layout component.
 * @param {PropsWithChildren<ErrorLayoutPropsInterface>} props - Props injected to the component. 
 * @returns {React.ReactElement}
 */
export const ErrorLayout: FunctionComponent<PropsWithChildren<ErrorLayoutPropsInterface>> = (
    props: PropsWithChildren<ErrorLayoutPropsInterface>
): ReactElement => {
 
    const {
        children,
        [ "data-componentid" ]: componentid
    } = props;

    const { deployment } = useConfig();

    return (
        <Container data-componentid={ componentid }>
            <AppHeader data-componentid="app-header" />
            <div className="error-display-wrapper">
                { children }
            </div>
            <Footer>
                <div className="footer">
                    { deployment?.ui?.appCopyright }
                </div>
            </Footer>
        </Container>
    );
};
